<div class="flex flex-1 flex-col">
  <div>
    <span class="text-sm text-slate-900">
      {{ "Autori" | transloco }}
    </span>
  </div>
  <dx-tag-box
    [value]="tags"
    [readOnly]="readOnly"
    [dataSource]="membersDataSource"
    displayExpr="display"
    valueExpr="value"
    [searchEnabled]="true"
    [multiline]="true"
    (onValueChanged)="onAuthorsChanged($event)"
  ></dx-tag-box>
</div>
